import React, { Fragment } from 'react';
import { FormGroup } from 'react-bootstrap';
import { H6, P, UL, LI } from '../../../AbstractElements';
import { CreateAccount, Donthaveaccount, orSigninwith } from '../../../Constant';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Twitter } from 'react-feather';

const SocialAuth = ({ btntext, logtext }) => {
  return (
    <Fragment>
      <div className='login-social-title'>
        <H6>{orSigninwith}</H6>
      </div>
      <div>
        <FormGroup className='form-group'>
          <UL className='login-social d-flex flex-row simple-list'>
            <LI>
              <a href='https://www.linkedin.com/login'>
                <Linkedin className=' me-0' />
              </a>
            </LI>
            <LI>
              <a href='https://twitter.com/'>
                <Twitter className='me-0' />
              </a>
            </LI>{' '}
            <LI>
              <a href='https://www.facebook.com/'>
                <Facebook className='me-0' />
              </a>
            </LI>
            <LI>
              <a href='https://www.instagram.com/'>
                <Instagram className='me-0' />
              </a>
            </LI>
          </UL>
        </FormGroup>
      </div>
      <P className='mt-4 mb-0 text-center'>
        {logtext ? logtext : Donthaveaccount}
        {!logtext && !btntext ? (
          <Link to={`${process.env.PUBLIC_URL}/auth/sign-up`} className='ms-2'>
            {CreateAccount}
          </Link>
        ) : (
          <Link to={`${process.env.PUBLIC_URL}/login`} className='ms-2'>
            {btntext}
          </Link>
        )}
      </P>
    </Fragment>
  );
};

export default SocialAuth;
